export const buildChartjsDataProp = (labels, data) => {
  return ({
    labels: labels,
    datasets: data.map(({ label, data, color }) => {
      return ({
        backgroundColor: color,
        borderColor: color,
        data: data,
        fill: true,
        label: label
      })
    })
  })
}
